export const selectClasses = {
  arrowWrapper: "select__arrowWrapper",
  arrow: "select__arrow",
  preview: "select__preview",
  clearButton: "select__clearButton",
  clearButtonContainer: "select__clearButtonContainer",
  startAdornment: "select__startAdornment",
};
